import React from 'react';
import PropTypes from 'prop-types';

export default function CustomInput({ type, id, value, onChange }) {
  return (
    <input
      type={type}
      id={id}
      className="w-full border-2 border-zinc-500 dark:border-zinc-400 rounded-lg py-2 px-3 mt-1 text-base outline-none text-zinc-500 dark:text-zinc-400 bg-white dark:bg-zinc-800 focus:border-cyan-500 dark:focus:border-cyan-600 focus-visible:border-cyan-500 dark:focus-visible:border-cyan-600"
      value={value}
      onChange={onChange}
    />
  );
}

CustomInput.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
